import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import { ROUTES_PATHS } from 'routes/constants';
import { MailIcn } from 'utils/icons';

const desktopClasses = 'h-[105px] max-w-[1500px] px-[30px] flex items-center justify-between mr-auto ml-auto text-white';
const mobileClasses = 'md:flex-col md:justify-center';
const policyClasses = 'text-white hover:text-purple-20 duration-300 text-right md:text-center';

const contacts = [
  { value: 'mailto:support@qtrack.io', title: 'support@qtrack.io', icon: MailIcn },
];

const Footer = () =>
  <footer className="bg-purple-100">
    <div className={`${desktopClasses} ${mobileClasses}`}>
      <p className="text-16 text-white">&copy; 2016-{dayjs().year()} Qtrack. All rights reserved.</p>
      <div className="flex flex-col gap-y-2 md:mt-2">
        <Link to={ROUTES_PATHS.policy} className={policyClasses}>Privacy Policy</Link>
        <div className="flex items-center gap-x-2">
          {contacts.map(({ title, value, icon: Icon }, key) => (
            <span key={key} className="flex text-14 items-center hover:text-purple-20">
              <Icon className="duration-300" />
              <a href={value}>&nbsp;{title}</a>
          </span>))}
        </div>
      </div>
    </div>
  </footer>;

export default Footer;
